const gameData = {
    isAdShownRecently: false,
    musicEnabled: true,
    soundEnabled: true,
    isAutoSpin: false,
};

// wrapper for working with localhost, which includes the validation of the data and is used to store the current state of the game

class GameDistribution {
    static get data() {
        return gameData;
    }

    static getProperty(prop) {
        return gameData[prop];
    }

    static setProperty(prop, value) {
        gameData[prop] = value;
        return gameData[prop];
    }
}

export default GameDistribution;
